import React from 'react';
import { Link } from 'react-router-dom';
import BankLogo from '../Common/BankLogo';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <div className="landing-content">
        <div className="logo-container">
          <BankLogo size={100} />
        </div>
        <h1 className="landing-title">DigiBank</h1>
        <p className="landing-subtitle">
          Modern Banking, Simplified
        </p>

        <div className="landing-buttons">
          <Link to="/login">
            <button className="btn btn-primary">Login</button>
          </Link>
          <Link to="/signup">
            <button className="btn btn-secondary">Sign Up</button>
          </Link>
        </div>

        <div className="features-section">
          <div className="feature">
            <div className="feature-icon">💸</div>
            <h3>Secure Transfers</h3>
            <p>Send money instantly with peace of mind</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📊</div>
            <h3>Smart Analytics</h3>
            <p>Track your spending with detailed insights</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🔒</div>
            <h3>24/7 Access</h3>
            <p>Manage your accounts anytime, anywhere</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
